<div id="teacher-profile-index" class="container margin-top-1" *ngIf="!loading">
 
  <form [formGroup]="form">
    <div class="container margin-auto">
      <mat-card>
        <div class="mat-h3 font-weight-bold profile-card-title">
          <i class="fas fa-user-circle"></i> {{ "personal-data" | translate }}
        </div>
        <span *ngIf="user.isPremium == true" class="active-premium">PREMIUM ACTIVO</span>
      
        <mat-card-title-group class="row">
          <!-- Photo -->
          <div class="flex-center col-3 margin-right-2">
            <mat-icon svgIcon="user" *ngIf="
                !(form.value.profile_photo_path || form.value.photo_base64);
                else photoTemplate
              " (click)="photo.click()" class="gallery-icon"></mat-icon>
            <input #photo type="file" accept="image/png,image/jpeg" (change)="onSelectFile($event.target, 'photo_base64')" style="display: none" />

            <ng-template #photoTemplate>
              <img id="photo" class="img-teacher" [src]="
                  form.value.profile_photo_path
                    ? form.value.profile_photo_path
                    : ''
                " (click)="photo.click()" />
            </ng-template>
          </div>
          <div class="col row">
            <!-- Name -->
            
            <mat-form-field appearance="legacy" class="margin-top-1 col-4">
              <mat-label>{{ "name" | translate }}</mat-label>
              <input class="form-control" matInput formControlName="name" name="given-name" autocomplete="given-name" />
              <mat-error *ngIf="
                  this.form.get('name')?.invalid &&
                  this.form.get('name')?.touched
                ">
                {{ "valid-input" | translate }}
              </mat-error>
            </mat-form-field>

            <!-- Surname -->
            <mat-form-field appearance="legacy" class="margin-top-1 col-8">
              <mat-label>{{ "surname" | translate }}</mat-label>
              <input class="form-control" matInput formControlName="surname" name="family-name" autocomplete="family-name" />
              <mat-error *ngIf="
                  this.form.get('surname')?.invalid &&
                  this.form.get('surname')?.touched
                ">
                {{ "valid-input" | translate }}
              </mat-error>
            </mat-form-field>

            <!-- email -->
            <mat-form-field appearance="legacy" class="margin-top-1 col">
              <mat-label>{{ "email" | translate }}</mat-label>
              <input class="form-control" matInput formControlName="email" name="email" autocomplete="email" />
              <mat-error *ngIf="
                  this.form.get('email')?.invalid &&
                  this.form.get('email')?.touched
                ">
                {{ "valid-input" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </mat-card-title-group>

        <div class="row">
          <!-- Phone -->
          <mat-form-field appearance="legacy" class="margin-top-1">
            <mat-label>{{ "phone" | translate }}</mat-label>
            <input class="form-control" matInput formControlName="phone" type="tel" />
            <mat-error *ngIf="phoneNoValido">
              {{ "valid-phone" | translate }}
            </mat-error>
          </mat-form-field>

          <!-- Birthdate -->
          <mat-form-field appearance="legacy" class="margin-top-1">
            <mat-label>{{ "birthday" | translate }}</mat-label>
            <input class="form-control" matInput formControlName="birthday" [matDatepicker]="picker" placeholder="DD/MM/YYYY" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="birthdayNoValido">
              {{ "valid-date" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="row">
          <!-- Gender -->
          <mat-form-field appearance="legacy" class="margin-top-1">
            <mat-label>{{ "gender" | translate }}</mat-label>
            <mat-select class="form-control" formControlName="gender">
              <mat-option [value]="gender" *ngFor="let gender of genders">{{ gender | translate }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="genderNoValido">
              {{ "valid-gender" | translate }}
            </mat-error>
          </mat-form-field>

          <!-- Country -->
          <app-autocomplete formControlName="country" label="country" validText="valid-select" [options]="countries" [atributeDisplay]="'name_' + general.translate.currentLang" [isInvalid]="
              form.controls.country?.invalid && form.controls.country?.touched
            "></app-autocomplete>

          <!-- City -->
          <mat-form-field appearance="legacy" class="margin-top-1 col-8">
            <mat-label>{{ "city" | translate }}</mat-label>
            <input class="form-control" matInput formControlName="custom_city_name" />
            <mat-error *ngIf="invalidCustomCityName">
              {{ "valid-input" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card class="mt-4">
        <div class="mt-4">
          <div class="mat-h3 font-weight-bold profile-card-title">Eliminar cuenta</div>
          <p class="small">
            Para eliminar tu cuenta haz clic en el siguiente botón, tu cuenta se dasactivará y podrás solicitar su reactivación. Si transcurridos 7 días desde la desactivación no has indicado lo contrario tu cuenta será eliminada de forma permanente. Si confirmas la eliminación de tu cuenta tu sesión actual se cerrará y no podrás volver a hacer login. Si quieres contactar con nosotros deberás hacerlo a través de la página de soporte.
          </p>
          <a class="btn btn-primary" (click)="sureDelAccount()">Eliminar cuenta</a>
        </div>
      </mat-card> 
      <mat-card class="margin-bottom-1 margin-top-2">
        <div class="mat-h3 font-weight-bold profile-card-title">
          <i class="fas fa-user-plus"></i> {{ "more-information" | translate }}
        </div>
        <!-- description -->
        <div style="
            color: #272129 !important;
            opacity: 0.5 !important;
            font-size: 16px;
            font-weight: 400;
            line-height: 1.125;
            font-family: Poppins;
          ">
          {{ "description-text" | translate }}
        </div>
        <mat-form-field appearance="legacy">
          <textarea matInput formControlName="description" type="text"></textarea>
          <mat-error *ngIf="invalidDescription">
            {{ "valid-description" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- goal_joining -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "goal_joining" | translate }}</mat-label>
          <mat-select class="form-control" formControlName="goal_joining">
            <!-- "goal-joining-teacher-1":"Tener una dedicación completa",
               "goal-joining-teacher-2":"Combinar con otro empleo",
               "goal-joining-teacher-3":"Desarrollar mi vocación",
               "goal-joining-teacher-4":"Trabajar de forma remota desde donde quiera",
               "goal-joining-teacher-5":"Otro motivo", -->
            <mat-option value="1">{{
              "goal-joining-teacher-1" | translate
              }}</mat-option>
            <mat-option value="2">{{
              "goal-joining-teacher-2" | translate
              }}</mat-option>
            <mat-option value="3">{{
              "goal-joining-teacher-3" | translate
              }}</mat-option>
            <mat-option value="4">{{
              "goal-joining-teacher-4" | translate
              }}</mat-option>
            <mat-option value="5">{{
              "goal-joining-teacher-5" | translate
              }}</mat-option>
          </mat-select>
          <mat-error *ngIf="invalidGoalJoining">
            {{ "valid-select" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- other_goal_joining -->
        <mat-form-field *ngIf="form.value.goal_joining === '5'" appearance="legacy" class="margin-top-1">
          <mat-label>{{ "other_goal_joining" | translate }}</mat-label>
          <input class="form-control" matInput formControlName="other_goal_joining" type="text" />
          <mat-error *ngIf="invalidOtherGoalJoining">
            {{ "valid-input" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- educational_level -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "educational_level" | translate }}</mat-label>
          <mat-select class="form-control" formControlName="educational_level">
            <!-- "educational_level_teacher_1": "Educación Primaria",
               "educational_level_teacher_2": "Educación Secundaria Obligatoria (ESO)",
               "educational_level_teacher_3": "Bachillerato",
               "educational_level_teacher_4": "Formación Profesional (FP)",
               "educational_level_teacher_5": "Enseñanzas universitarias", -->
            <mat-option value="1">{{
              "educational_level_teacher_1" | translate
              }}</mat-option>
            <mat-option value="2">{{
              "educational_level_teacher_2" | translate
              }}</mat-option>
            <mat-option value="3">{{
              "educational_level_teacher_3" | translate
              }}</mat-option>
            <mat-option value="4">{{
              "educational_level_teacher_4" | translate
              }}</mat-option>
            <mat-option value="5">{{
              "educational_level_teacher_5" | translate
              }}</mat-option>
          </mat-select>
          <mat-error *ngIf="invalidEducationalLevel">
            {{ "valid-select" | translate }}
          </mat-error>
        </mat-form-field>

        <!-- dedication_time -->
        <mat-form-field appearance="legacy" class="margin-top-1">
          <mat-label>{{ "dedication_time" | translate }}</mat-label>
          <mat-select class="form-control" formControlName="dedication_time">
            <!-- "dedication_time_teacher_1": "5 días a la semana",
               "dedication_time_teacher_2": "2-3 días a la semana",
               "dedication_time_teacher_3": "1 día a la semana",
               "dedication_time_teacher_4": "Esporádicamente", -->
            <mat-option value="1">{{
              "dedication_time_teacher_1" | translate
              }}</mat-option>
            <mat-option value="2">{{
              "dedication_time_teacher_2" | translate
              }}</mat-option>
            <mat-option value="3">{{
              "dedication_time_teacher_3" | translate
              }}</mat-option>
            <mat-option value="4">{{
              "dedication_time_teacher_4" | translate
              }}</mat-option>
          </mat-select>
          <mat-error *ngIf="invalidDedicationTime">
            {{ "valid-select" | translate }}
          </mat-error>
        </mat-form-field>

        <div class="row">
          <!-- price_hour_single -->
          <mat-form-field appearance="legacy" class="margin-top-1 col">
            <mat-label>{{ "price_hour_single" | translate }}</mat-label>
            <input class="form-control" matInput formControlName="price_hour_single" type="number" onkeydown="return event.keyCode !== 69" />
            <mat-error *ngIf="
                form.controls.price_hour_single?.invalid &&
                form.controls.price_hour_single?.touched
              ">
              {{ "valid-input" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card>

      <!-- Languages -->
      <div formArrayName="languages" class="margin-top-2">
        <mat-card class="form-group" *ngFor="
            let subject of languagesFormArray.controls;
            let index = index;
            let last = last;
            let first = first
          ">
          <div class="mat-h3 font-weight-bold profile-card-title">
            <i class="fas fa-globe-europe"></i> {{ "languages-to-talk" | translate }}
          </div>
          <div class="flex-end">
            <button mat-icon-button (click)="removeLanguage(index)">
              <mat-icon svgIcon="minus-circle" color="warn"></mat-icon>
            </button>
          </div>
          <div [formGroupName]="index">
            <mat-form-field appearance="legacy" class="margin-top-1">
              <mat-label>{{ "language" | translate }}</mat-label>
              <mat-select class="form-control" formControlName="language_id">
                <mat-option [value]="language.id" *ngFor="let language of languages">{{ language.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="
                  subject.controls.language_id?.invalid &&
                  subject.controls.language_id?.touched
                ">
                {{ "valid-select" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="legacy" class="margin-top-05">
              <mat-label>{{ "level" | translate }}</mat-label>
              <mat-select class="form-control" formControlName="level_id">
                <mat-option [value]="level.id" *ngFor="let level of languageLevels">{{ level.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="
                  subject.controls.level_id?.invalid &&
                  subject.controls.level_id?.touched
                ">
                {{ "valid-select" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </mat-card>
        <div class="flex-center margin-top-1">
          <button type="button" class="btn btn-success" (click)="addLanguage()">
            <div class="flex-center">
              <span class="margin-right-05">{{
                "add-another-1" | translate
                }}</span>
              <mat-icon svgIcon="plus"></mat-icon>
            </div>
          </button>
        </div>
      </div>

      <div class="row justify-content-center">
        <!-- Button -->
        <button mat-raised-button color="primary" class="width-50 margin-top-1 margin-bottom-2 padding-05" [disabled]="!validateform" [class.spinner]="sending" (click)="sendform()">
          <span>{{ "save" | translate }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
